export let exportMenu = [
	{
		icon: "uil-clipboard-notes sidebar-icon",
		children: [
			{
				title: true,
				i18n: "documents",
			},
			{
				url: "/documents-in",
				i18n: "good_reception",
				icon: "uil-bring-front",
			},
			{
				url: "/documents-preparation",
				i18n: "preparation",
				icon: "uil-apps",
				permission: "documents_preparation",
				active: false,
			},
			{
				url: "/write-off",
				i18n: "write_off",
				icon: "uil-trash-alt",
				permission: "documents_write_off",
				active: false,
			},
			{
				title: true,
				i18n: "reports",
			},
			{
				url: "/report/dashboard",
				i18n: "home",
				icon: "uil-chart-pie-alt",
			},
			{
				url: "/report/summary",
				i18n: "summary_report",
				icon: "uil-chart-pie-alt",
			},
			{
				url: "/report/cheques",
				i18n: "cheques",
				icon: "uil-chart-pie-alt",
			},
			{
				url: "/report/shifts",
				i18n: "shifts",
				icon: "uil-chart-pie-alt",
			},
			{
				url: "/report/z-report",
				i18n: "z_report",
				icon: "uil-chart-pie-alt",
			},
			{
				url: "/report/documents-in",
				i18n: "good_reception",
				icon: "uil-chart-pie-alt",
			},
			{
				url: "/report/documents-preparation",
				i18n: "preparation",
				icon: "uil-chart-pie-alt",
			},
			{
				url: "/report/sales",
				i18n: "sales",
				icon: "uil-chart-pie-alt",
			},
			{
				url: "/report/cashiers",
				i18n: "cashiers",
				icon: "uil-chart-pie-alt",
			},
			{
				url: "/report/expenses",
				i18n: "income_expense",
				icon: "uil-chart-pie-alt",
			},
			{
				url: "/report/gross-income",
				i18n: "gross_income",
				icon: "uil-chart-pie-alt",
				permission: "report_gross_income",
				active: false,
			},
			{
				title: true,
				i18n: "debit_credit",
			},
			{
				url: "/report-suppliers",
				i18n: "suppliers",
				icon: "uil-chart-pie-alt",
			},
			{
				url: "/report-clients",
				i18n: "clients",
				icon: "uil-chart-pie-alt",
			},
			{
				url: "/report-balance",
				i18n: "balance2",
				icon: "uil-chart-pie-alt",
			},
			{
				url: "/report-balance-2",
				i18n: "balance_by_category",
				icon: "uil-chart-pie-alt",
			},

		]
	},
	{
		icon: "uil-setting sidebar-icon",
		children: [
			{
				title: true,
				i18n: "settings",
			},
			{
				url: "/pos",
				i18n: "pos",
				icon: "uil-shop",
				active: false,
			},
			{
				url: "/products",
				i18n: "products",
				icon: "uil-shopping-cart",
				active: false,
			},
			{
				url: "/product-statuses",
				i18n: "product_statuses",
				icon: "uil-shopping-cart",
				active: false,
			},
			{
				url: "/wms",
				i18n: "warehouse",
				icon: "uil-store",
				active: false,
			},
			{
				url: "/clients",
				i18n: "clients",
				icon: "uil-user",
				active: false,
			},
			{
				url: "/clients-types",
				i18n: "client_types",
				icon: "uil-user",
				active: false,
			},
			{
				url: "/employees",
				i18n: "employees",
				icon: "uil-users-alt",
				active: false,
			},
			{
				url: "/employees-types",
				i18n: "employee_types",
				icon: "uil-users-alt",
			},
			{
				url: "/units",
				i18n: "units",
				icon: "uil-cell",
			},
			{
				url: "/payment-types",
				i18n: "payment_types",
				icon: "uil-transaction",
				permission: "payment_types",
				active: false,
			},
			{
				url: "/payment-purposes",
				i18n: "income_expense",
				icon: "uil-coins",
			},
			{
				url: "/categories",
				i18n: "categories",
				icon: "uil-web-section-alt",
			},
			{
				url: "/delivery-types",
				i18n: "delivery_type",
				icon: "uil-truck",
			},
			{
				url: "/suppliers",
				i18n: "suppliers",
				icon: "uil-truck-loading",
			},
			{
				url: "/currency",
				i18n: "currency",
				icon: "uil-transaction",
			},
			{
				url: "/accounts",
				i18n: "accounts",
				icon: "uil-moneybag",
			},
		]
	},
]